import React, { useState, useEffect } from "react";
import "../../../src/home.css";
import { useGetPageQuery } from "../../redux/slices/pageSlice";
import { renderContentBlocks } from "./block";
import Loader from "../../component/loader/index";
import ReportIcon from "../../component/reportIcon";
import WaterMark from "../../component/watermark";
import DeletedPage from "../deletedPage";
import VisibilityPage from "../Visibility";
import defaultStyle from "../../utils/default";
import { useDispatch, useSelector } from "react-redux";
import { setColor } from "../../redux/slices/backgroundColor";
import { getAverageRGB } from "../../utils/getAveragergb";
import { useAppContext } from './../../util'

function Home() {
  
  const { userId, pageId } = useAppContext()

  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.modal.isOpen);

  // fetch data from Api
  const { data, error, isLoading } = useGetPageQuery(
    `/api/v1/page/web/${userId}/${pageId}`,
    {
      skip: userId ? false : true,
    }
  );

  // set data in state
  const [page, setPage] = useState(null);
  useEffect(() => {
    if (data?.contentBlocks) {
      let temp = [...data?.contentBlocks];
      let contentSort = temp.sort(function compare(a, b) {
        let contentA = a.blockOrder;
        let contentB = b.blockOrder;
        return contentA - contentB;
      });
      setPage([...contentSort]);
    }
  }, [data?.contentBlocks]);

  const gradientBackground = `linear-gradient(to bottom, ${data?.pageStyles?.background?.topGradient}, ${data?.pageStyles?.background?.bottomGradient}) no-repeat fixed`;

  const backgroundType =
    data?.pageStyles?.background?.type || defaultStyle.background.type;

  const backgroundColor =
    data?.pageStyles?.background?.color || defaultStyle.background.color;

  const backgroundImage =
    data?.pageStyles?.background?.image || defaultStyle.background.image;
  const fonts = data?.pageStyles?.font || defaultStyle.font;

  const handleFont = {
    SpaceGrotesk: "Space Grotesk",
    Poppins: "Poppins",
    Inter: "Inter",
    Raleway: "Raleway",
    RobotoSlab: "Roboto Slab",
    NotoSerif: "Noto Serif",
  };

  const getBackgroundStyle = () => {
    if (backgroundType === "gradient") {
      return {
        background: gradientBackground,
        fontFamily: handleFont[fonts] ? handleFont[fonts] : "Poppins",
        objectFit: "cover",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      };
    } else if (backgroundType === "color") {
      return {
        background: backgroundColor,
        fontFamily: handleFont[fonts] ? handleFont[fonts] : "Poppins",
      };
    } else {
      document.body.style.background = `url(${backgroundImage} )`;
      document.body.style.backgroundAttachment = "fixed";
      document.body.style.backgroundRepeat = "no-repeat";
      document.body.style.backgroundPosition = "center";
      document.body.style.backgroundSize = "cover";
      dispatch(setColor(`url(${backgroundImage} )`));
      return { fontFamily: handleFont[fonts] ? handleFont[fonts] : "Poppins" };
    }
    // } else {
    //   return {
    //     background: `url(${backgroundImage})`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //     backgroundAttachment: "fixed",
    //     fontFamily: handleFont[fonts] ? handleFont[fonts] : "Poppins",
    //   };
    // }
  };

  const appBackgroundStyle = getBackgroundStyle();

  useEffect(() => {
    if (data) {
      document.body.style.background =
        backgroundType === "gradient"
          ? gradientBackground
          : backgroundType === "color"
          ? backgroundColor
          : "null";

      if (backgroundType === "gradient") {
        dispatch(setColor(gradientBackground));
      } else if (backgroundType === "color") {
        dispatch(setColor(backgroundColor));
      }
    }
  }, [data]);

  useEffect(() => {
    SetBackground(data?.pageStyles?.background?.image);
  }, [data]);

  function SetBackground(url) {
    var img = new Image();
    var rgb;
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      rgb = getAverageRGB(img);
      document.body.style.background =
        "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
      dispatch(setColor("rgb(" + rgb?.r + "," + rgb?.g + "," + rgb?.b + ")"));
    };

    img.src = url;
  }

  if (!userId || !pageId) {
    return (
      <div id="i" className="wrapper">
        <div
          className="container"
          style={{
            ...appBackgroundStyle,
            minHeight: "100vh",
            opacity: 1,
            padding: !isLoading && page?.length <= 0 ? "0px" : "10px",
            marginBottom: !isLoading && page?.length === 0 ? "0px" : "72px",
          }}
        >
          <p style={{ color: "#1f2937", textAlign: "center" }}>
            Missing userId or pageId.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div id="i" className="wrapper">
      {/* show loader when page is loading */}
      {isLoading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader width={"50px"} />
        </div>
      ) : (
        <>
          {/* render delete page if page is not present*/}
          {!data ? (
            <DeletedPage />
          ) : (
            <>
              {data?.visibility ? (
                <div
                  className="container"
                  style={{
                    ...appBackgroundStyle,
                    minHeight: "100vh",
                    opacity: 1,
                    padding: !isLoading && page?.length <= 0 ? "0px" : "10px",
                    marginBottom:
                      !isLoading && page?.length === 0 ? "0px" : "72px",
                  }}
                >
                  {page?.length > 0 &&
                    renderContentBlocks(data, page, userId, pageId)}
                  {!isLoading && page?.length <= 0 && <VisibilityPage />}

                  {page?.length > 0 && (
                    <>
                      {data?.showQubioLogo == true && !isModalOpen ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "fixed",
                            left: "0px",
                            right: "0px",
                            bottom: "10px",
                          }}
                        >
                          <WaterMark />
                        </div>
                      ) : null}
                      {isModalOpen ? (
                        ""
                      ) : (
                        <ReportIcon userId={userId} pageId={pageId} />
                      )}
                    </>
                  )}
                </div>
              ) : (
                // render component if page visibility is false
                <VisibilityPage />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}
// export default Component
export default Home;
